export default {"src":"/pro/_next/static/media/jup.6b5a0f9b.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};